import { GetterTree } from "vuex";
import { StoreState } from "@/store/type";
import { IChurningState } from "@/modules/Churning/vuex/state";

const getters: GetterTree<IChurningState, StoreState> = {
  churningData: (state) => state.churningData,
  isFetchingChurning: (state) => state.isLoading,
  churningError: (state) => state.error,
};

export default getters;
